/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import queryString from 'query-string'
import { injectIntl } from 'react-intl'

import SearchField from './../SearchField'
import FixedSidebar from '../FixedSidebar'
import Dropdown from '../Dropdown'
import Button from '../Button'
import routes from './../../constants/routes'
import { getSVG, removeLogMetaDataByKey, clearAuthFromStorage } from './../../helpers/util'

import './Navbar.scss'
import { APP_AUTH_NAME } from '../../constants'

const context = get(window, '__APP_ENV__.CONTEXT')
const commonIcon = getSVG('common')
const samlLogin = JSON.parse( get(window, '__APP_ENV__.samlLogin', 'false') )

// const hamburgerIcon = getSVG('hamburger')

const Navbar = ({
  history,
  match,
  title,
  location,
  auth,
  intl,
  isShore,
  shipName,
  isShipMode,
  voyageName,
  settings,
  shouldShowAlertList,
  shouldShowCrewList,
  shouldShowCrewRolesManagement,
  shouldShowBoardingSlots,
  shouldShowBoardingCount,
  shouldShowGuestList,
  shouldShowIPMDutiesList,
  shouldShowMessageList,
  shouldShowSettings,
  shouldShowVisitorList,
  shouldShowReportList,
  shouldShowDashboard,
  latestBoardingSlot,
  totalActiveSlotsCount,
  shouldShowCreateReservation,
  shouldShowMasterTemplate,
  shouldShowStateroom,
  shouldShowVoyagePortTerminals, 
  shouldShowPortTerminals,
  shouldShowCbpDashboard
}) => {
  const toggleSidebar = () => {
    let toggle = document.querySelector('.navbar-burger')
    toggle.classList.toggle('is-active')
    let menu = document.querySelector('.navbar-menu')
    menu.classList.toggle('show')
  }

  const closeSidebar = () => {
    let toggle = document.querySelector('.navbar-burger')
    toggle.classList.remove('is-active')
    let menu = document.querySelector('.navbar-menu')
    menu.classList.remove('show')
  }

  const handleSearchKeyDown = (event, inputValue) => {
    event.preventDefault()
    if (!isEmpty(inputValue)) {
      history.push(
        `${match.path}/${routes.results}?searchTerm=${inputValue}`
      )
    }
  }

  const handleLogout = () => {
    clearAuthFromStorage()
    localStorage.removeItem('roles')
    sessionStorage.removeItem('roles')
    localStorage.removeItem(APP_AUTH_NAME)
    removeLogMetaDataByKey('loggedInUserDetail')
    if (!samlLogin) {
      window.location.href = `${match.path}/${routes.login}`
    } else {
      const encoded = encodeURIComponent(`${window.location.origin}/${context}/`)
      window.location = `${window.location.origin}/${context}/slogout?redirectUri=${encoded}`
      // window.location = `http://localhost:5000/${context}/slogout?redirectUri=${encoded}`
    }
  }

  return (
    <div className="NavbarContainer__div">
      <div className="NavbarHeader">
        <div className="columns is-mobile">
          <div className="column is-1-touch">
            <div className="columns is-mobile">
              <div className="column is-hidden-desktop">
                <Button
                  role="button"
                  className="is-icon-button navbar-burger burger"
                  onClick={toggleSidebar}
                >
                  <span aria-hidden="true" />
                  <span aria-hidden="true" />
                  <span aria-hidden="true" />
                </Button>
              </div>
              <div className="column is-hidden-touch">
                <strong className="is-size-5">{title}</strong>
              </div>
            </div>
          </div>
          <div className="column is-11-touch">
            <div className="columns is-mobile">
              <div className="column is-11">
                <SearchField
                  onChange={() => { }}
                  onKeyDown={handleSearchKeyDown}
                  placeholder={intl.formatMessage({
                    id: 'Navbar.search',
                    defaultMessage: 'Search'
                  })}
                  value={queryString.parse(location.search).searchTerm}
                  shouldEnableSearchGuidelines={get(settings, 'search.shouldEnableSearchGuidelines', false)}
                />
              </div>
              <div className="column is-1 LogoutContainer__div">
                <Dropdown
                  id="LogoutLogo"
                  content={
                    <span className="navbar-item logout is-uppercase">{`${get(
                      auth,
                      'userProfileDetail.firstName',
                      ''
                    ).substring(0, 1)}${get(
                      auth,
                      'userProfileDetail.lastName',
                      ''
                    ).substring(0, 1)}`}</span>
                  }
                >
                  <li className="dropdown-item">
                    <img alt="Avatar" className="avatar" src={commonIcon} />
                    <span className="name">
                    {
                      get(settings, 'isShowUserName', false) ? 
                        get( auth, 'userProfileDetail.userName', '' )
                      :
                        `${get( auth, 'userProfileDetail.firstName', '' )} ${get(auth, 'userProfileDetail.lastName', '')}`
                    }
                    </span>
                  </li>
                  <hr className="dropdown-divider"></hr>
                  <li className="dropdown-item">
                    <span>
                      {intl.formatMessage({
                        id: 'Navbar.duty',
                        defaultMessage: 'Duty'
                      })}
                    </span>
                    <span className="is-pulled-right">
                      {get(
                        auth,
                        'userProfileDetail.roleDetail[0].applicationRoles[0].name',
                        '--'
                      )}
                    </span>
                  </li>
                  <hr className="dropdown-divider"></hr>
                  <li className="dropdown-item">
                    <Button
                      isFullWidth
                      onClick={handleLogout}
                      className="button is-primary"
                    >
                      {intl.formatMessage({
                        id: 'Navbar.logout',
                        defaultMessage: 'Logout'
                      })}
                    </Button>
                  </li>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="navbar-menu is-hidden-desktop" onClick={closeSidebar}>
        <div className="columns">
          <div className="column one">
            <FixedSidebar
              closeSidebar={closeSidebar}
              isShore={isShore}
              shipName={shipName}
              voyageName={voyageName}
              shouldShowCrewList={shouldShowCrewList}
              shouldShowCrewRolesManagement={shouldShowCrewRolesManagement}
              shouldShowGuestList={shouldShowGuestList}
              shouldShowBoardingSlots={shouldShowBoardingSlots}
              shouldShowBoardingCount={shouldShowBoardingCount}
              shouldShowIPMDutiesList={shouldShowIPMDutiesList}
              shouldShowVisitorList={shouldShowVisitorList}
              shouldShowSettings={shouldShowSettings}
              shouldShowCreateReservation={shouldShowCreateReservation}
              shouldShowMasterTemplate={shouldShowMasterTemplate}
              shouldShowStateroom={shouldShowStateroom}
              shouldShowAlertList={shouldShowAlertList}
              shouldShowMessageList={shouldShowMessageList}
              shouldShowReportList={shouldShowReportList}
              shouldShowVoyagePortTerminals={shouldShowVoyagePortTerminals}
              shouldShowPortTerminals={shouldShowPortTerminals}
              settings={settings}
              totalActiveSlotsCount={totalActiveSlotsCount}
              latestBoardingSlot={latestBoardingSlot}
              isShipMode={isShipMode}
              shouldShowDashboard={shouldShowDashboard}
              shouldShowCbpDashboard={shouldShowCbpDashboard}
            />
          </div>
          <div className="column" onClick={closeSidebar} />
        </div>
      </div>
    </div>
  )
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  auth: PropTypes.shape({}),
  isShore: PropTypes.bool,
  shipName: PropTypes.string,
  voyageName: PropTypes.string,
  shouldShowAlertList: PropTypes.bool,
  shouldShowCrewList: PropTypes.bool,
  shouldShowCrewRolesManagement: PropTypes.bool,
  shouldShowGuestList: PropTypes.bool,
  shouldShowBoardingSlots: PropTypes.bool,
  shouldShowBoardingCount: PropTypes.bool,
  shouldShowIPMDutiesList: PropTypes.bool,
  shouldShowMessageList: PropTypes.bool,
  shouldShowSettings: PropTypes.bool,
  shouldShowVisitorList: PropTypes.bool,
  shouldShowReportList: PropTypes.bool,
  settings: PropTypes.shape({}),
  totalActiveSlotsCount: PropTypes.string,
  latestBoardingSlot: PropTypes.shape({}),
  isShipMode: PropTypes.string,
  shouldShowDashboard: PropTypes.bool,
  shouldShowCreateReservation: PropTypes.bool,
  shouldShowMasterTemplate:PropTypes.bool,
  shouldShowStateroom: PropTypes.bool,
  shouldShowVoyagePortTerminals: PropTypes.bool, 
  shouldShowPortTerminals: PropTypes.bool,
  shouldShowCbpDashboard: PropTypes.bool
}

Navbar.defaultProps = {
  auth: {},
  settings: {},
  shipName: '',
  voyageName: '',
  isShore: false,
  shouldShowAlertList: false,
  shouldShowVisitorList: false,
  shouldShowCrewList: false,
  shouldShowCrewRolesManagement: false,
  shouldShowGuestList: false,
  shouldShowBoardingSlots: false,
  shouldShowBoardingCount: false,
  shouldShowIPMDutiesList: false,
  shouldShowMessageList: false,
  shouldShowSettings: false,
  shouldShowReportList: false,
  shouldShowDashboard: false,
  shouldShowCreateReservation: false,
  shouldShowStateroom: false,
  shouldShowVoyagePortTerminals: false, 
  shouldShowPortTerminals: false,
  shouldShowCbpDashboard: false
}

export default injectIntl(withRouter(Navbar))
